import React from "react";
import editIcon from "../../../../static/images/edit-icon.png";
import { signedLockedAccess } from "../../../../utils";

export const CharacteristicProgressViewMode = ({ styles, assessmentDetails, assessmentDetailsNew, woundProgressOptions, hideIt, onEdit, isReadOnly }) => (
  <>
    {signedLockedAccess(assessmentDetails?.assessmentStage) && hideIt && (
      <button className={`float-sm-right ${styles.tab_edit}`} onClick={onEdit} disabled={isReadOnly}>
        <img src={editIcon} alt="edit" />
        Edit
      </button>
    )}
    <p>
      <label>Wound Progress:</label>
      <span>
        {assessmentDetailsNew?.woundStage
          ? woundProgressOptions?.find((data) => data.key === assessmentDetailsNew.woundStage.toLowerCase())?.value
          : "-"}
      </span>
    </p>
  </>
);
